import { useEffect, useState } from "react";
import { Col, Row, Tabs, Tooltip } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";
import React from "react";
// import {CUSTOMER_ROLE } from "../../../../../config/Constant";
// import { fetchList as fetchCompanyList } from "../../../Company/utils/slice";
// import { fetchCareercategory } from "../../../../../store/CommonSlice";
// import { useAppDispatch } from "../../../../../utils/hooks/hooks";
// import { RootState } from "../../../../../store/app";

// import { dateCompare } from "../../../../../config/Global";
// import { useDispatch, useSelector } from "react-redux";

import { fetchIndustryCategoryList } from "../../utils/slice";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";
import { fetchCareersList } from "../../../../../store/CommonSlice";
import { InfoCircleOutlined } from "@ant-design/icons";

/**
 * Renders a form component for adding or editing a record in the Cms module.
 *
 * @param {object} props - The component props.
 * @param {object} props.form - The form instance.
 * @param {string} props.id - The form ID.
 * @param {function} props.handleSubmit - The function to handle form submission.
 * @param {function} props.onValuesChange - The function to handle form value changes and update the form fields.
 * @param {object} props.editValues - The values to edit in the form fields, if value already exists.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
    form,
    id,
    handleSubmit,
    onValuesChange,
    editValues,
}) => {


    const dispatch = useAppDispatch();
    const [categoryList, setCategoryList] = useState<any>([]);



    useEffect(() => {
        if (editValues) {
            form.setFieldsValue({
                ...editValues,
                is_show: editValues?.is_show ? [editValues?.is_show] : [],
            });
        }
        dispatch(fetchIndustryCategoryList())
            .then((data: any) => {
                setCategoryList(data.rows);
            })
            .catch((error: any) => error);



    }, [editValues, form]);

    /**
     * Process the form data and handle the form submission.  
     */
    const onFinish = (data: any) => {

        data.is_show = data?.is_show != undefined && data.is_show?.length > 0 && data.is_show[0] != undefined ? data.is_show[0] : 0;

        if (data.description !== String(data.description)) {
            data.description = data?.description?.level?.content;
        }
        handleSubmit(data);
    };


    return (
        <>
            <FormBox
                form={form}
                id={id}
                onFinish={onFinish}
                onValuesChange={onValuesChange}
            >
                <Row gutter={15}>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 24 }}>
                        <InputBox.Text required name="industry_name" label="Industry Name" />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 24 }}>
                        <InputBox.Select
                            required
                            label="Category"
                            name="category_id"
                            showSearch
                            className="singleSelect"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                                0
                            }
                            options={{
                                list: categoryList,
                                valueKey: "id",
                                textKey: "name",
                            }}
                        />

                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <InputBox.Checkbox
                            name="is_show"
                            options={{
                                list: [
                                    {
                                        id: 1,
                                        name: "Is Visible",
                                    },
                                ],
                            }}

                        />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <InputBox.Checkbox
                            disabled={true}
                            value={[editValues?.is_available]}
                            options={{
                                list: [
                                    {
                                        id: 1,
                                        name: "Is Active",
                                    },
                                ],
                            }}

                        />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 24 }}>
                        <InputBox.Editor
                            name="description"
                            label="Description"
                            initValue={form.getFieldValue("description")}
                            editorChange={(e: any) => {
                                form.setFieldsValue({ description: e });
                                onValuesChange();
                            }}
                        />

                    </Col>
                </Row>
            </FormBox>

        </>
    );
};

export default FormComponent;
